export const contractCheckout = {
  'Card number': 'Número do cartão',
  'Name printed on card': 'Nome impresso no cartão',
  'Choose your payment method, {{name}}':
    'Escolha seu método de pagamento, {{name}}',
  Credit: 'Crédito',
  CVC: 'Código de segurança',
  'Expiry date': 'Data de vencimento',
  Installments: 'Parcelamento',
  main: 'principal',
  'Make payment': 'Efetuar pagamento',
  'New card': 'Novo cartão',
  'New credit card': 'Novo cartão de crédito',
  'Pay with {{flag}}': 'Pagar com {{flag}}',
  'Pending issues successfully paid!': 'Pendências pagas com sucesso!',
  'Select the credit card': 'Selecione o cartão de crédito',
  'Main card of the contract': 'Cartão principal do contrato',
  'The new card will be charged first in the next installments The current card remains linked and will be tried if the charge on the new card is not approved':
    'As próximas parcelas serão cobradas primeiro no novo cartão. O cartão atual continua vinculado e será tentado se a cobrança no novo cartão não for aprovada.',
  'Your current card remains as the main payment method The new card will be tried only when the charge on the main card is not approved':
    'Seu cartão atual continua como método principal. O novo cartão será tentado apenas quando a cobrança no cartão principal não for aprovada.',
  'I authorize linking this card to my contract as the main payment method for the next installments':
    'Autorizo vincular este cartão ao meu contrato como método de pagamento principal das próximas parcelas.',
  'I authorize linking this card to my contract as a secondary payment method, to be charged when the main card is not approved':
    'Autorizo vincular este cartão ao meu contrato como método de pagamento secundário, para ser cobrado quando o cartão principal não for aprovado.',
  'Payment not approved': 'Pagamento não aprovado',
  'Your payment was not approved You can try again with the same card or choose another one':
    'Seu pagamento não foi aprovado. Você pode tentar novamente com o mesmo cartão ou escolher outro.',
  'Try again': 'Tentar novamente',
};
